import React from "react"
import logoUrl from "../../../assets/img/payment-icons/visa.svg"

export default function VisaLogo({ sx }: { sx: React.CSSProperties }) {
    return (
        <img
            src={logoUrl} loading="lazy"
            alt="Visa logo"
            style={sx}
        />
    )
}
